import { render, staticRenderFns } from "./roadmap_milestones.vue?vue&type=template&id=6859539c"
import script from "./roadmap_milestones.vue?vue&type=script&lang=js"
export * from "./roadmap_milestones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports